import React from "react";
import { X, Download } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function CVVersionViewModal({ version, onClose, onDownload }) {
  const { t } = useLanguage();
  const cv = version.adapted_cv || {};
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="cv-version-view-modal" onClick={onClose}>
      <div className="bg-white rounded-2xl max-w-xl w-full max-h-[85vh] overflow-y-auto p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="font-poppins font-bold text-lg text-slate-900">{version.version_name}</h3>
            <p className="text-xs text-slate-500">{version.target_job_title} · {version.target_company_name}</p>
          </div>
          <button onClick={onClose} data-testid="cv-version-view-close-btn" className="text-slate-400 hover:text-slate-600">
            <X className="h-5 w-5" />
          </button>
        </div>

        {cv.summary && (
          <div className="mb-4">
            <p className="text-xs font-bold text-slate-900 uppercase tracking-wide mb-1.5">{t("cvAdapt.summaryTitle")}</p>
            <p className="text-sm text-slate-600">{cv.summary}</p>
          </div>
        )}

        {cv.skills?.length > 0 && (
          <div className="mb-4">
            <p className="text-xs font-bold text-slate-900 uppercase tracking-wide mb-1.5">{t("cvAdapt.skillsTitle")}</p>
            <div className="flex flex-wrap gap-1.5">
              {cv.skills.map((s, i) => (
                <span key={i} className="text-xs font-semibold px-2.5 py-1 rounded-full bg-[#028CF8]/10 text-[#028CF8]">{s}</span>
              ))}
            </div>
          </div>
        )}

        {cv.experience?.length > 0 && (
          <div className="mb-4">
            <p className="text-xs font-bold text-slate-900 uppercase tracking-wide mb-1.5">{t("cvAdapt.experienceTitle")}</p>
            <div className="space-y-2">
              {cv.experience.map((e, i) => (
                <div key={i} className="border border-slate-100 rounded-xl p-3">
                  <p className="text-xs font-semibold text-slate-900">{e.position} · {e.company}</p>
                  <p className="text-[10px] text-slate-400 mb-1">{e.start_date} – {e.current ? t("cv.currentJob") : e.end_date}</p>
                  {e.description && <p className="text-xs text-slate-600">{e.description}</p>}
                </div>
              ))}
            </div>
          </div>
        )}

        <button onClick={onDownload} data-testid="cv-version-view-download-btn"
          className="w-full h-11 mt-2 flex items-center justify-center gap-2 bg-[#028CF8] text-white text-sm font-semibold rounded-xl hover:bg-[#0270C5] transition-all">
          <Download className="h-4 w-4" /> {t("cvAdapt.downloadPdf")}
        </button>
      </div>
    </div>
  );
}
